var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99964 5.99609C8.81107 5.99609 9.99621 6.11838 10.9025 6.23038C11.5962 6.31495 12.0374 7.01095 11.7619 7.65209C11.0956 9.19952 10.0648 10.635 8.5105 11.595C8.357 11.6899 8.1801 11.7401 7.99964 11.7401C7.81917 11.7401 7.64228 11.6899 7.48878 11.595C5.9345 10.635 4.90364 9.19952 4.23735 7.65209C3.96192 7.01095 4.40307 6.31495 5.09564 6.23038C6.00307 6.11952 7.18821 5.99609 7.99964 5.99609Z",
    fill: "#828282",
    stroke: "#828282",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleDownIcon);
export default __webpack_public_path__ + "static/media/triangle-down-icon.52471f03f83678a36f69fb34bca70b0d.svg";
export { ForwardRef as ReactComponent };